/**
 * SEO-метаданные по маршрутам SPA.
 * @typedef {Object} RouteSeoEntry
 * @property {string} title
 * @property {string} description
 * @property {string} [keywords]
 * @property {string} [robots] — index,follow | noindex,nofollow
 * @property {string[]} [jsonLd] — ключи из buildPageJsonLd
 * @property {string} [ogImagePath]
 */

/** @type {Record<string, RouteSeoEntry>} */
export const ROUTE_SEO = {
    '/': {
        title: 'Оборудование для бассейна онлайн — Welland Create | Казахстан',
        description:
            'Подберите насос, фильтр и теплообменник для бассейна онлайн — бесплатно. ' +
            '3D модель в реальном времени, PDF-спецификация за 3 минуты. Pahlen, Emaux, Landy. Алматы, Казахстан.',
        keywords:
            'оборудование для бассейна Алматы, оборудование для бассейна Казахстан, ' +
            'подбор насоса для бассейна онлайн, песочный фильтр для бассейна цена, ' +
            'купить теплообменник для бассейна Алматы, тепловой насос для бассейна цена, ' +
            'электронагреватель для бассейна купить, хлоринатор для бассейна цена, ' +
            'УФ лампа для бассейна, прожектор RGB для бассейна купить, ' +
            'лестница для бассейна нержавеющая цена, закладные элементы для бассейна, ' +
            'ПВХ плёнка для бассейна Казахстан, мозаика для бассейна Алматы, ' +
            'скиммерный бассейн оборудование, переливной бассейн оборудование, ' +
            'бассейн под ключ Алматы, Pahlen Казахстан, Emaux Казахстан',
        robots: 'index, follow',
        jsonLd: ['organization', 'webApplication', 'webSite', 'localBusiness', 'faqPage', 'howTo'],
        ogImagePath: '/og-cover.png',
    },
    '/login': {
        title: 'Вход - Welland Create',
        description: 'Войдите в Welland Create, чтобы сохранять проекты бассейна и выгружать коммерческие предложения.',
        keywords: 'Welland Create вход, личный кабинет Welland',
        robots: 'noindex, nofollow',
    },
    '/register': {
        title: 'Регистрация - Welland Create',
        description: 'Создайте аккаунт Welland Create для проектирования бассейна и расчёта комплекта оборудования.',
        keywords: 'Welland Create регистрация, создать аккаунт',
        robots: 'noindex, nofollow',
    },
    '/reset-password': {
        title: 'Восстановление пароля - Welland',
        description: 'Восстановление доступа к аккаунту Welland Create.',
        robots: 'noindex, nofollow',
    },
    '/dashboard': {
        title: 'Мои проекты - Welland Create',
        description: 'Личный кабинет Welland Create: сохранённые проекты бассейнов и коммерческие предложения.',
        robots: 'noindex, nofollow',
    },
    '/app': {
        title: 'Редактор бассейна - Welland Create',
        description: '3D редактор и калькулятор оборудования для бассейна Welland Create.',
        robots: 'noindex, nofollow',
    },
    '/privacy': {
        title: 'Политика конфиденциальности - Welland Create',
        description: 'Политика конфиденциальности сервиса Welland Create. Как мы обрабатываем и защищаем данные пользователей.',
        keywords: 'политика конфиденциальности Welland, обработка данных',
        robots: 'index, follow',
    },
    '/terms': {
        title: 'Условия использования - Welland Create',
        description: 'Условия использования онлайн-сервиса Welland Create для подбора оборудования и проектирования бассейна.',
        keywords: 'условия использования Welland, пользовательское соглашение',
        robots: 'index, follow',
    },
};

const FALLBACK = ROUTE_SEO['/'];

export const GLOBAL_KEYWORDS =
    // Общие запросы
    'бассейн, оборудование для бассейна, Welland, Welland Create, Казахстан, Алматы, ' +
    'купить оборудование для бассейна, подбор оборудования для бассейна онлайн, ' +
    // Оборудование по категориям
    'насос для бассейна, песочный фильтр для бассейна, ' +
    'теплообменник для бассейна, электронагреватель для бассейна, тепловой насос для бассейна, ' +
    'дезинфекция бассейна, хлоринатор для бассейна, ультрафиолет для бассейна, ' +
    'прожектор для бассейна RGB, освещение для бассейна, лестница для бассейна нержавеющая, ' +
    'закладные элементы для бассейна, скиммер для бассейна, форсунка для бассейна, ' +
    'донный слив для бассейна, переливная решетка для бассейна, ' +
    'ПВХ плёнка для бассейна, мозаика для бассейна, отделка бассейна, ' +
    // Геолокация
    'бассейн Алматы, бассейн Астана, бассейн Шымкент, ' +
    'скиммерный бассейн, переливной бассейн, бассейн под ключ Казахстан, ' +
    // Бренды
    'Pahlen, Emaux, Landy, Elbe, Espa, Kripsol, Glong, ' +
    'Reviglass, Altoglass, Cefil, CGT, Ezzari, ' +
    'Vortex, Elecro, BWT, Aqualine, Procopi, Max Dapra, HX, IML';

/**
 * @param {string} pathname
 * @returns {RouteSeoEntry}
 */
export function resolveRouteSeo(pathname) {
    const path = pathname.split('?')[0].split('#')[0] || '/';
    return ROUTE_SEO[path] || FALLBACK;
}
